import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PAYRATE,
  DELETE_PAYRATE,
  UPDATE_PAYRATE,
  ADD_NEW_PAYRATE,
} from "./actionType";

import {
  getPayrateSuccess,
  getPayrateFail,
  deletePayrateSuccess,
  deletePayrateFail,
  updatePayrateSuccess,
  updatePayrateFail,
  addPayrateSuccess,
  addPayrateFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePayrateApi,
  getPayrateApi,
  updatePayrateApi,
  deletePayrateApi,
  addNewPayrateApi
} from "../../helpers/backend_helper";

function* getPayrate({ payload: payrate }) {
  try {
    const response = yield call(getPayrateApi, payrate);
    yield put(getPayrateSuccess(GET_PAYRATE, response.data));
  } catch (error) {
    yield put(getPayrateFail(GET_PAYRATE, error));
  }
}

function* onUpdatePayrate({ payload: payrate }) {
  try {
    if (payrate.setApprove) {
      const response = yield call(approvePayrateApi, payrate);
      yield put(updatePayrateSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePayrateApi, payrate);
      yield put(updatePayrateSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePayrateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePayrate({ payload: payrate }) {
  try {
    const response = yield call(deletePayrateApi, payrate);
    yield put(deletePayrateSuccess({ payrate, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePayrateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPayrate({ payload: payrate }) {
  try {
    const response = yield call(addNewPayrateApi, payrate);
    yield put(addPayrateSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPayrateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPayrate() {
  yield takeEvery(GET_PAYRATE, getPayrate);
}

export function* watchUpdatePayrate() {
  yield takeEvery(UPDATE_PAYRATE, onUpdatePayrate);
}

export function* watchDeletePayrate() {
  yield takeEvery(DELETE_PAYRATE, onDeletePayrate);
}

export function* watchAddNewPayrate() {
  yield takeEvery(ADD_NEW_PAYRATE, onAddNewPayrate);
}

function* payrateSaga() {
  yield all([
    fork(watchGetPayrate),
    fork(watchDeletePayrate),
    fork(watchUpdatePayrate),
    fork(watchAddNewPayrate)
  ]);
}

export default payrateSaga;
